import * as React from 'react';
import TimeTaxSupportSystemClient from '../../../system';
import MessageCourier from '../../../lib/MessageCourier';
import { ICommandBarItemProps, Text } from '@fluentui/react';
import { buttonStylesForProjects, defaultCommandBarButtonStyles } from '../../../styles/button-styles';
import { routes } from '../../../common/constants';
import ViewWrapperWithCommandBar from '../../Layout/ViewWrapperWithCommandBar';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../../../common/custom-hooks/useIsMobile';
import CollaboratorPanels from '../../Collaborator/CollaboratorView/CollaboratorPanels';
import { User } from '../../../system/User';
import { useTranslation, Trans } from 'react-i18next';
import Loading from '../../Spinners/Loading';

interface ICompanyPanel {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (change: boolean) => void;
  user: User;
  loading?: boolean;
}

export const PanelOwn = (props: ICompanyPanel) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();

  const items = React.useMemo((): ICommandBarItemProps[] => {
    let ret: ICommandBarItemProps[] = [
      {
        key: 'project',
        text: t('Mi Panel'),
        onClick: () => navigate(`${routes.dashboard_own}`),
        itemProps: {},
        iconProps: { iconName: 'BIDashboard' },
        buttonStyles: buttonStylesForProjects,
      },
      {
        key: 'download',
        text: t('Avance de proyectos'),
        onClick: () => navigate(`${routes.dashboard}`),
        iconProps: { iconName: 'TeamWork' },
        buttonStyles: defaultCommandBarButtonStyles,
      },
      {
        key: 'avance_por_sector',
        text: t('Avance por sector'),
        onClick: () => navigate(`${routes.dashboard_avance_por_sector}`),
        iconProps: { iconName: 'BarChart4' },
        buttonStyles: defaultCommandBarButtonStyles,
      },
      {
        key: 'panel_companies',
        text: t('Empresas'),
        onClick: () => navigate(`${routes.dashboard_empresas}`),
        iconProps: { iconName: 'CityNext2' },
        buttonStyles: defaultCommandBarButtonStyles,
      },
      {
        key: 'colabs',
        text: t('Colaboradores'),
        onClick: () => navigate(`${routes.dashboard_colaboradores}`),
        iconProps: { iconName: 'ReminderPerson' },
        buttonStyles: defaultCommandBarButtonStyles,
      },
    ];

    if (props.user.getProfile().isStandardUser()) {
      ret = [ret[0]];
    }

    return ret;
  }, [navigate, props.user]);

  if (!props.loading) {
    return <Loading title='Cargando' description='Por favor espere estamos procesando la información necesaria para completar su solicitud.'/>
  }

  return (
      <ViewWrapperWithCommandBar
          withBorderBottom
          title={''}
          items={items}
          overflowButtonStyles={defaultCommandBarButtonStyles}
          // overflowItems={overflowItems}
          variant="highligth"
          titleBody={t('Panel')}
      >
        {isMobile && <Text variant="xLarge" block styles={{ root: { fontWeight: 600, padding: '1rem 1rem 0' } }}>{t('Mi Panel')}</Text>}
        <div className="ms-Grid padding-1" dir="ltr">
          <CollaboratorPanels
              user={props.user}
              system={props.system}
              courier={props.courier}
              changeBlockUI={props.changeBlockUI}
          />
        </div>
      </ViewWrapperWithCommandBar>
  );
};
